import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import { Category } from '../../types';

import * as S from './styles';

type Props = {
  category: Category;
  closeMenu: () => void;
  showSidebar: boolean;
};

const ViewAllButton = ({ category, closeMenu, showSidebar }: Props) => {
  const { t, linkTo } = useContext(AppContext);

  return (
    <S.ViewAllMenuItem
      name={
        showSidebar
          ? t('header', 'mobile-menu.show-all')
          : t('header', 'mega-menu.show-all-in-category', {
              name: category.name,
            })
      }
      link={linkTo('category', category)}
      onClick={closeMenu}
      sidebar={showSidebar}
      showArrow={false}
    />
  );
};

export default ViewAllButton;
